import { useEffect, useMemo, useState } from "react";

import { computeSceneGraphDiagramData } from "./layout";

export function useSceneGraphDiagramData({
  bodies,
  sceneGraphBodiesSignature,
  effectiveWorldBodies,
  joints,
  sites,
  meshes,
  cameras,
  actuators,
  tendons,
  equalities,
  effectiveHiddenTypes,
}) {
  const [structureTick, setStructureTick] = useState(0);

  useEffect(() => {
    const handler = () => setStructureTick((x) => x + 1);
    window.addEventListener("structure-changed", handler);
    return () => window.removeEventListener("structure-changed", handler);
  }, []);

  // Pure layout calculation lives in `./layout.js`. Keep this dependency list
  // in sync with the inputs that function actually reads.
  return useMemo(
    () =>
      computeSceneGraphDiagramData({
        bodies,
        effectiveWorldBodies,
        joints,
        sites,
        meshes,
        cameras,
        actuators,
        tendons,
        equalities,
        effectiveHiddenTypes,
      }),
    // sceneGraphBodiesSignature/structureTick are in the dep list so structural
    // edits that mutate body objects in place still trigger recomputation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      bodies,
      sceneGraphBodiesSignature,
      effectiveWorldBodies,
      joints,
      sites,
      meshes,
      cameras,
      actuators,
      tendons,
      equalities,
      structureTick,
      effectiveHiddenTypes,
    ]
  );
}
